import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="w-full py-12 px-6 border-t border-[#E8E6E3] bg-[#FAF9F7]" data-id="element-62">
      <div className="max-w-5xl mx-auto flex flex-col items-center gap-6 text-sm text-[#9B9B9B] md:flex-row md:items-center md:justify-between md:gap-8" data-id="element-63">
        {/* Navigation Links */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 md:gap-x-8" data-id="element-64">
          <Link to="/about" className="hover:text-[#5C5C5C] transition-colors duration-200 font-medium" data-id="element-65">
            About
          </Link>
          <Link to="/switch" className="hover:text-[#5C5C5C] transition-colors duration-200 font-medium" data-id="element-66">
            Switch to Andoe
          </Link>
          <Link to="/docs" className="hover:text-[#5C5C5C] transition-colors duration-200 font-medium" data-id="element-67">
            AI Search Course
          </Link>
          <Link to="/blog" className="hover:text-[#5C5C5C] transition-colors duration-200 font-medium" data-id="element-68">
            Blog
          </Link>
          <Link to="/contact" className="hover:text-[#5C5C5C] transition-colors duration-200 font-medium" data-id="element-69">
            Contact
          </Link>
          <Link to="/privacy" className="hover:text-[#5C5C5C] transition-colors duration-200 font-medium" data-id="element-70">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-[#5C5C5C] transition-colors duration-200 font-medium" data-id="element-71">
            Terms of Service
          </Link>
        </div>

        {/* Copyright + Social */}
        <div className="flex items-center gap-6" data-id="element-72">
          <div className="font-medium" data-id="element-73">Andoe ©2026</div>
          <div className="flex items-center gap-4" data-id="element-74">
            <a href="https://www.linkedin.com/company/andoe/" target="_blank" rel="noopener noreferrer" className="hover:text-[#5C5C5C] transition-colors duration-200" aria-label="LinkedIn" data-id="element-75">
              <Linkedin className="h-4 w-4" data-id="element-76" />
            </a>
            <a href="https://www.instagram.com/andoe.work/" target="_blank" rel="noopener noreferrer" className="hover:text-[#5C5C5C] transition-colors duration-200" aria-label="Instagram" data-id="element-77">
              <Instagram className="h-4 w-4" data-id="element-78" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}